import React from "react";
import classes from "./BarHeader.module.scss";

type QuizHeaderProps = {
  title: string;
};

const BarHeader = (props: QuizHeaderProps) => {
  return (
    <div className={classes.quizHeader}>
      <div>{props.title}</div>
    </div>
  );
};

export default BarHeader;
